import { FiArrowRight } from "react-icons/fi";
import PromoImg from "../img/promo_img1.png";

// static promotional band (matches CameraX "Pixel Perfect" banner)
export default function PromoBand() {
  return (
    <section className="mb-20">
      <div className="container mx-auto">
        <div className="relative overflow-hidden rounded-card border border-border bg-surface px-8 py-12 md:px-16 md:py-16 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h3 className="font-display text-3xl md:text-4xl font-semibold mb-3">
              Pixel Perfect. Splash-proof.
            </h3>
            <p className="text-muted mb-4">
              A new benchmark in optical performance.
            </p>
            <div className="text-2xl font-semibold mb-5">
              From <span className="text-brand">$449</span>
            </div>
            <a
              href="https://joemar-ceneza-e-commerce-camera-haus.netlify.app/"
              className="inline-flex items-center gap-x-2 uppercase tracking-wide font-semibold text-brand hover:gap-x-3 transition-all">
              View Now <FiArrowRight />
            </a>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src={PromoImg}
              alt="Featured camera"
              className="w-full max-w-[420px] object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
